import { createSlice, createSelector } from "@reduxjs/toolkit";

const tasksSlice = createSlice({
  name: "tasks",
  initialState: { activeTasks: [] },
  reducers: {
    addTask: (state, action) => {
      const { id, type, groupTask } = action.payload;
      state.activeTasks.push({ id, type, groupTask, started_datetime: new Date() });
    },
    removeTask: (state, action) => {
      const { id } = action.payload;
      state.activeTasks = state.activeTasks.filter((task) => task.id !== id);
    },
  },
});

export const { addTask, removeTask } = tasksSlice.actions;

export default tasksSlice.reducer;
export const selectActiveTaskIds = (state) => state.tasks.activeTasks.map((task) => task.id);

// Base selector for active tasks
const selectActiveTasks = (state) => state.tasks.activeTasks;

// Memoized selector factory for filtering tasks by type
export const selectActiveTasksByType = (taskType) =>
  createSelector([selectActiveTasks], (activeTasks) =>
    activeTasks.filter((task) => task.type === taskType)
  );
